const DESKTOP_STYLES = {
  refine: { width: 'auto', height: 46 },
  location: { width: 'auto', height: 29 },
  cart: { width: 'auto', height: 26 },
  filter: { width: 'auto', height: 28, marginTop: 6 },
};

const MOBILE_STYLES = {
  refine: { width: 'auto', height: 40 },
  location: { width: 'auto', height: 30 },
  cart: { width: 'auto', height: 28 },
  filter: { width: 'auto', height: 28, marginTop: 4 },
  grid: { width: 'auto', height: 25 },
  list: { width: 'auto', height: 25 },
};


export const getIconStyle = (iconName, isPhone) => {
  if (isPhone) {
    return MOBILE_STYLES[iconName];
  }

  return DESKTOP_STYLES[iconName];
}



// WEBPACK FOOTER //
// ./src/icons/icon_utils.js